// export function formatSortCode(sortCode: string | number) {
// 	const sortCodeAsStr = (typeof sortCode === 'number') ? sortCode.toString(10) : sortCode;
// 	const fragments = [...(sortCodeAsStr.match(/../g) || []), ];
// 	return fragments.join('-');
// }

export function formatAccountNumber(accountNumber: string | number, obfuscate = true) {
	const accountNumberAsStr = (typeof accountNumber === 'number') ? accountNumber.toString(10) : accountNumber;
	return obfuscate ? accountNumberAsStr.replace(/^..../, '****') : accountNumberAsStr;
}

export function formatSortCode(sortCode: string | number, obfuscate?:boolean) {
	const sortCodeAsStr = (typeof sortCode === 'number') ? sortCode.toString(10) : sortCode;
	const replaceWithX = sortCodeAsStr.replace(/.(?=.{2})/g, 'X') || '';
	const firstTwoDigits = obfuscate ? replaceWithX.substring(0, 2) : sortCodeAsStr.substring(0, 2);
	const nextTwoDigits = obfuscate ? replaceWithX.substring(2, 4) : sortCodeAsStr.substring(2, 4);
	const lastTwoDigits = sortCodeAsStr.substring(4);
	return `${firstTwoDigits}-${nextTwoDigits}-${lastTwoDigits}`;
}
